<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="line-scale-pulse-out" [fullScreen]="true">
	<p style="color: white">{{'LOADING' | translate}} </p>
</ngx-spinner>
<app-toasts></app-toasts>
<app-display-selfreg-card *ngIf="selfRegCardData" 
	[userRef]="selfRegCardData.userRef" 
	[pin]="pin" 
	[axonId]="axonId"
	[textFields]="selfRegCardData.fields"
	[image]="selfRegCardData.image"
	[qrImage]="selfRegCardData.qrImage"></app-display-selfreg-card>